import React from 'react';

interface ISectionTitleProps {
  title: string;
  subTitle1: string;
  subTitle2: string;
  description: string;
  className: string;
}

const SectionTitle: React.FunctionComponent<ISectionTitleProps> = ({
  title,
  subTitle1,
  subTitle2,
  description,
  className,
}) => (
  <div className={className}>
    <h1 className="header" dangerouslySetInnerHTML={{ __html: title }} />
    <div className="title">
      <div className="l1" dangerouslySetInnerHTML={{ __html: subTitle1 }} />
      <div className="l2" dangerouslySetInnerHTML={{ __html: subTitle2 }} />
    </div>
    <p className="content" dangerouslySetInnerHTML={{ __html: description }} />
  </div>
);

export default SectionTitle;
